import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';
import { targetPriceType } from './constants';
import { ResultProps, TargetPriceWrapperProps } from './types';

const TargetPriceWrapper = styled.div.attrs(
  (props: TargetPriceWrapperProps) => ({
    targetType: props.targetType,
  }),
)<TargetPriceWrapperProps>`
  width: 100%;
  border: 1px solid ${color.gainsboro};
  border-left: 6px solid
    ${({ targetType }) => targetPriceType[targetType].color};
  padding: 20px 15px 20px 23px;
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 3px;
`;

const TextBorder = styled(Text).attrs({ size: '12px', padding: '2px 0' })`
  border-top: 1px solid ${color.highempahis};
  width: fit-content;
`;

const ButtonVote = styled(Button).attrs({
  height: '45px',
  block: true,
  round: true,
})`
  img {
    position: absolute;
    left: 10px;
    top: 10px;
    height: 24px;
  }
`;

const ResultWrapper = styled(Flex).attrs({ align: 'center' })`
  height: 60px;
  border: 1px solid ${color.silver};
  border-radius: 3px;
`;

const Result = styled(Flex).attrs((props: ResultProps) => ({
  background: props.background || color.light,
  direction: 'column',
  justify: 'center',
  align: 'center',
}))<ResultProps>`
  width: 50%;
  height: 100%;
  background: ${({ background }) => background};
  :last-child {
    border-left: 1px solid ${color.silver};
  }
`;

export { TargetPriceWrapper, TextBorder, ButtonVote, ResultWrapper, Result };
